/** Prefer competition registration name over account first/last name. */
export function contestantDisplayName(source) {
  const contestant = source?.contestant || source;
  const fullName = String(contestant?.full_name || source?.full_name || "").trim();
  if (fullName) return fullName;

  const user = contestant?.user;
  if (user) {
    const accountName = `${user.firstName || ""} ${user.lastName || ""}`.trim();
    if (accountName) return accountName;
  }

  return "Contestant";
}
